module.exports = __webpack_public_path__ + "media/sub3-7-1.bab2d8b0.mp4";